module.exports = __webpack_public_path__ + "img/ticket4_g.a7b7fa5d.svg";